import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Position } from "../../../api";
import { useSCBOneOperationRuns } from "../../../api/api.scb-one";
import "../../../styles/card.scss";
import { BaseCard } from "../../BaseCard";
import { SelectedOperationRun } from "../../details/SCBOneDetails";
import {
  TimeRangeSelection,
  useTimeRangeSelection,
} from "../../TimeRangeSelection";
import { OperationRunsDrawer } from "./OperationRunsDrawer";
import { SCBOneOperationsRunsTable } from "./OperationRunsTable";

interface SCBOneOperationRunsCardProps {
  serial: string;
  positions: Position[];
  positionsLoading: boolean;
  selectedRow: string | undefined;
  onRowSelected: (selectedRun: SelectedOperationRun) => void;
}

export function SCBOneOperationRunsCard({
  serial,
  positions,
  positionsLoading,
  selectedRow,
  onRowSelected,
}: SCBOneOperationRunsCardProps) {
  const { t } = useTranslation();

  const [operationRunsDrawerVisible, setOperationRunsDrawerVisible] =
    useState(false);

  const {
    selectedFromToFilter,
    fromToFilterOptions,
    selectedFromToFilterOptionIndex,
    onSelectFilterOption,
    onSelectCustomTimeFrame,
  } = useTimeRangeSelection(serial);

  const operationRuns = useSCBOneOperationRuns(serial, selectedFromToFilter);
  
  return (
    <BaseCard title={t("scb-one:operation-runs-title")} allowScroll={true}>
      <SCBOneOperationsRunsTable
        operationRuns={operationRuns}
        positions={positions}
        positionsLoading={positionsLoading}
        selectedRow={selectedRow}
        onRowSelected={onRowSelected}
      />
      <OperationRunsDrawer
        operationRuns={operationRuns}
        positions={positions}
        positionsLoading={positionsLoading}
        operationRunsDrawerVisible={operationRunsDrawerVisible}
        selectedRow={selectedRow}
        onRowSelected={onRowSelected}
        onCloseDrawer={(visible) => setOperationRunsDrawerVisible(visible)}
      />
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          height: "55px",
          backgroundColor: "white",
          padding: "1rem",
          zIndex: 1000,
        }}
      >
        <TimeRangeSelection
          fromToFilterOptions={fromToFilterOptions}
          selectedFromToFilterOptionIndex={selectedFromToFilterOptionIndex}
          customTimeRangeLabel={t("time-range-picker:user-defined")}
          onSelectFilterOption={onSelectFilterOption}
          onSelectCustomTimeFrame={onSelectCustomTimeFrame}
        />
        <div style={{ position: "absolute", bottom: 10, right: 5 }}>
          <Button
            type="primary"
            onClick={() => setOperationRunsDrawerVisible(true)}
            icon={<PlusOutlined />}
          />
        </div>
      </div>
    </BaseCard>
  );
}
